import { render } from "./FormatHeader1.vue?vue&type=template&id=5243a127"
import script from "./FormatHeader1.vue?vue&type=script&lang=js"
export * from "./FormatHeader1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__